import { z } from 'zod'

export const PiloteInstitutionOrientationZod = z.enum(['NORTH', 'SOUTH', 'EAST', 'WEST'])
export type PiloteInstitutionOrientation = z.infer<typeof PiloteInstitutionOrientationZod>
export const PiloteInstitutionRecordZod = z.object({
  id: z.number(),
  name: z.string(),
  phone_number: z.string(),
  civic_number: z.string().nullable(),
  street: z.string().nullable(),
  latitude: z.number(),
  longitude: z.number(),
  orientation: PiloteInstitutionOrientationZod.nullable(),
})
